import React from 'react';
import FullWidthLayout from '../layouts/FullWidthLayout';
import './LoginPage.css';
import Container from '../components/Container';
import Typography from '@mui/joy/Typography';
import List from '@mui/joy/List';
import ListDivider from '@mui/joy/ListDivider';
import Sheet from '@mui/joy/Sheet';
import * as Accordion from '@radix-ui/react-accordion';

import { AccordionHeader, AccordionContent } from '../components/JoyAccordion';
import BackArrow from '../components/BackArrow';
import Row from '../components/Row';


const FAQPage = () => {
  return (
    <FullWidthLayout className="ContractPage">
      <Container>
        <Sheet sx={{ p: 2 }}>
          <Row flexDirection='row'>
            <div style={{ marginTop: 10, paddingRight: 10 }}>
              <BackArrow />
            </div>
            <Typography level="h1">
              Frequently asked questions
            </Typography>
          </Row>
          <List
            component={Accordion.Root}
            type="multiple"
            defaultValue={['item-1']}
          >
            <Accordion.Item value="item-1">
              <AccordionHeader isFirst>
                How do I get into the marketplace?
              </AccordionHeader>
              <AccordionContent>
                The &tag Marketplace is currently in Private Beta. If you have been invited to the Private Beta, you should have received an email from us. Please follow the instructions in that email, or message the & team member who invited you.
              </AccordionContent>
            </Accordion.Item>

            {/* <ListDivider component="div" /> */}

            <Accordion.Item value="item-2">
              <AccordionHeader>
                What is your refund policy?
              </AccordionHeader>
              <AccordionContent>
                We understand that honest mistakes can happen, like misspelling the &tag you wanted to buy. We want to assure you that we are here to assist you in the event that you need a refund. Our policy allows for one refund request per 48 hours, up to a maximum of three times per year.
                <br />
                <br />
                To initiate a refund, please contact our customer support team with a detailed explanation of the issue. If your refund request is approved, we will promptly initiate the refund process. Please note that refund processing times may vary depending on the payment method used.
                <br />
                <br />
                We value your satisfaction and are committed to providing excellent service. If you have any questions or concerns about our refund policy, please email our support team at support@andme.org.
              </AccordionContent>
            </Accordion.Item>

            {/* <ListDivider component="div" /> */}

            <Accordion.Item value="item-3">
              <AccordionHeader isLast>
                Where is my NFT?
              </AccordionHeader>
              <AccordionContent isLast>
                Premium &tags are Non-Fungible Tokens (NFTs) that are stored on the Ripple blockchain network.
              </AccordionContent>
            </Accordion.Item>
          </List>
        </Sheet>
      </Container>
    </FullWidthLayout>
  );
};

export default FAQPage;
